export { EditMode } from '@imagise/entities';

export enum PictureUnit {
  Pixels,
  Percentage,
  AspectRatio,
}

export enum ElementTransformOperation {
  None,
  Move,
  ResizeN,
  ResizeS,
  ResizeE,
  ResizeW,
  ResizeNE,
  ResizeNW,
  ResizeSE,
  ResizeSW,
}

export enum FilterTypes {
  None,
  Exposure,
  Grayscale,
  Inverse,
  Binarize,
  Sharpen,
  Outline,
  MotionBlur,
  Emboss,
  Sobel,
  GaussianBlur,
  ColorBurn,
  Cartoon,
  BigRectangular,
  SmallRectangular,
  Median,
  GaussWiener,
  MotionWiener,
  BilateralSmoothing,
}

/** Direction of the Sobel edge-detection kernel. */
export enum SobelFilterTypes {
  Top,
  Bottom,
  Left,
  Right,
}
